import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const ORDER_EXCEPTIONS_TRACING_ACTIONS = {
  traceSubmitExceptions: createAction(
    '[NGRXTrace - Order] Submit Exceptions',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitExceptionsSuccess: createAction(
    '[NGRXTrace - Order] Submit Exceptions Success',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitExceptionsSuccessWebSocket: createAction(
    '[NGRXTrace - Order] Track Submit Exceptions Websocket Response Success',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitExceptionsFail: createAction(
    '[NGRXTrace - Order] Submit Exceptions Fail',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitExceptionsSuccessWithExceptions: createAction(
    '[NGRXTrace - Order] Submit Exceptions Fail',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSubmitExceptionsSuccessWithExceptionsWebSocket: createAction(
    '[NGRXTrace - Order] Track Submit Exceptions Websocket Response Fail',
    props<{
      tracking;
    }>(),
  ),
  traceViewExceptionsLinkClickedFromSubmittedOrder: createAction(
    '[NGRXTrace - Order] View Exceptions Link Clicked from Submitted Order',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceViewExceptionsLinkClickedFromOrderConf: createAction(
    '[NGRXTrace - Order] View Exceptions Link Clicked from Order Conf',
    props<{
      tracking: Tracking;
    }>(),
  ),
  tracePageLoad: createAction(
    '[NGRXTrace - Order] Resolve Exceptions Page Load',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
